<div class="con">
  <!-- <div class="title">
    <h1>Safey Indicators</h1>
  </div> -->
 <div style="text-align: center;" >

 
      
  <div class="centered-header">{{'Safety Indicators' | translate | async}} </div>
  <div class="centered-header">{{previousYear}} - {{currentMonth}} </div>
  
  <mat-form-field >
    <mat-select placeholder="{{'All State' | translate | async}}" (selectionChange)="GetTRIFRForLast12Months();GetObservationQuestionMonthlyhours();GetTRIFRIncidentsForLast12Months(); GetHRFRForLast12Months()"  [(ngModel)]="stateID" name="Site" [formControl]="state" required>   
      <mat-option [value]="0">{{'All States' | translate | async}}</mat-option>
      <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
        {{Site.SiteName}} </mat-option>
      </mat-select> 
      <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
  </mat-form-field>
  
  <div style="display: flex; flex-wrap: wrap;">
    <div class="sc-dashboard-category">

        <fusioncharts
  [width]="width"
  [height]="height"
  [type]="type"
  [dataFormat]="dataFormat"
  [dataSource]="dataSource"
>
</fusioncharts>
    </div>
</div>
</div>
</div>